const CoordinatorResitRegistrationTitle = 'Resit Registration';
const candidateRegisterForAnExamLabel = 'Register for an Exam';
const AppealForResultReview = 'Appeal for Review of Results';
const SUBJECT_AMENDMENT = 'Subject Amendment';
const NEW_SUBJECT_AMENDMENT = 'New Subject Amendment';
const coordinatorRegisterForAnExamLabel = 'Register for an Exam';
const EXAM_REGISTRATION = 'exam-registrations';
const REGISTERED_EXAM = 'Registered Exam(s)';
const EXAM_WITHDRAWAL = 'Exam Withdrawal';
const VIEW_APPLICATION = 'View Application';
const VIEW_REGISTRATION = 'View Registration';
const accessArrangementTitle = 'Apply for Access Arrangements';
const specialConsiderationTitle = 'Apply for Special Consideration';
const SPECIAL_CONSIDERATION = 'special-consideration';
const statementOfResultsTitle = 'Statement of Results';
const STATEMENT_OF_RESULTS = 'statement-of-results';
const SELECT_SUBJECT = 'select-subject';
const REVIEW_APPLICATION = 'review-application';
const VIEW_SUMMARY = 'view-summary';
const CONFIRM_AND_PAY = 'confirm-and-pay';
const USEFUL_INFORMATION = 'useful-information';
const UPLOAD_ADDITIONAL_RESOURCES = 'upload-additional-resources';
const NOTIFICATION_ACKNOWLEDGEMENT = 'notification-acknowledgement';

const key = {
  auth: {
    child: {
      createAccount: 'create-account',
      createCandidate: 'create-candidate',
      successfulAccountCreation: 'successful-account-creation',
      login: 'login',
      forgotUsername: 'forgot-username',
      forgotPassword: 'forgot-password',
      resetPassword: 'reset-password',
      setPassword: 'set-password',
      otp: 'otp',
      activateAccount: 'activate-account',
      activated: 'activated',
      editProfile: 'edit-profile',
      success: 'success',
      updatePassword: {
        route: 'update-password',
        title: 'Update Password',
      },
      unlockAccount: 'unlock-account',
    },
  },
  profile: {
    child: {
      createCandidate: {
        route: 'create-candidate',
        title: 'Create Candidate',
      },
      candidateDetail: {
        route: 'candidate-profile',
        title: 'Candidate Profile',
      },
      coordinatorDetail: {
        route: 'coordinator-profile',
        title: 'Coordinator Profile',
      },
      detail: {
        route: 'detail',
        title: 'Detail',
      },
      emailAlert: {
        route: 'email-alert',
        title: 'Email Alert',
      },
      settings: {
        route: 'settings',
        title: 'Settings',
      },
      adminDetail: {
        route: 'admin-profile',
        title: 'My Profile',
      },
      requestForAmendment: {
        route: 'request-for-amendment',
        title: 'Request for Amendment',
      },
      uploadSupportingDocuments: {
        route: 'upload-supporting-documents',
        title: 'Upload Supporting Document(s)',
      },
    },
  },
  amendment: {
    child: {
      examRegistrations: {
        route: EXAM_REGISTRATION,
        title: REGISTERED_EXAM,
      },
      listing: {
        route: 'listing',
        title: REGISTERED_EXAM,
      },
      registration: {
        route: 'registration',
        title: SUBJECT_AMENDMENT,
      },
      editRegistration: {
        route: 'edit-registration',
        title: SUBJECT_AMENDMENT,
      },
      addSubject: {
        route: 'add-subject',
        title: SUBJECT_AMENDMENT,
      },
      reviewSubjects: {
        route: 'review-subjects',
        title: SUBJECT_AMENDMENT,
      },
      registeredExams: {
        route: 'registered-exams',
        title: SUBJECT_AMENDMENT,
      },
      reviewParticulars: {
        route: 'review-particulars',
        title: SUBJECT_AMENDMENT,
      },
      confirmAmendmentDetails: {
        route: 'confirm-amendment-details',
        title: SUBJECT_AMENDMENT,
      },
      receipt: {
        route: 'receipt',
        title: SUBJECT_AMENDMENT,
      },
      viewDetails: {
        route: 'view-details',
        title: VIEW_REGISTRATION,
      },
      transactionHistoryAmendment: {
        route: 'transaction-history-amendment',
        title: VIEW_REGISTRATION,
      },
      coordinatorExamRegistrations: {
        route: 'group-exam-registrations',
        title: SUBJECT_AMENDMENT,
      },
      coordinatorRegistration: {
        route: 'registration',
        title: 'New Amendment',
      },
      coordinatorSelectCandidate: {
        route: 'select-candidate',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorEditRegistration: {
        route: 'edit-candidate-registration',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorAddSubject: {
        route: 'add-candidate-subject',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorReviewSubjects: {
        route: 'review-candidate-subjects',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorReviewParticulars: {
        route: 'review-candidate-particulars',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorConfirmAmendmentDetails: {
        route: 'confirm-candidate-amendment-details',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorViewCandidateReceipt: {
        route: 'view-candidate-receipt',
        title: NEW_SUBJECT_AMENDMENT,
      },
      coordinatorViewDetails: {
        route: 'view-candidate-details',
        title: NEW_SUBJECT_AMENDMENT,
      },
    },
  },
  withdrawal: {
    child: {
      examRegistrations: {
        route: EXAM_REGISTRATION,
        title: REGISTERED_EXAM,
      },
      instruction: {
        route: 'instruction',
        title: EXAM_WITHDRAWAL,
      },
      reason: {
        route: 'reason',
        title: EXAM_WITHDRAWAL,
      },
      review: {
        route: 'review',
        title: EXAM_WITHDRAWAL,
      },
      submitted: {
        route: 'submitted',
        title: EXAM_WITHDRAWAL,
      },
      summary: {
        route: VIEW_SUMMARY,
        title: VIEW_APPLICATION,
      },
      transactionHistorySummary: {
        route: 'transaction-history-summary',
        title: VIEW_APPLICATION,
      },
      additionalDocuments: {
        route: 'additional-documents',
        title: EXAM_WITHDRAWAL,
      },
      // coordinator
      withdrawal: {
        route: 'withdrawal',
        title: 'Withdraw',
      },
      selectCandidates: {
        route: 'select-candidates',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalInstruction: {
        route: 'non-national-instruction',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalReason: {
        route: 'non-national-reason',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalReview: {
        route: 'non-national-review',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalReceipt: {
        route: 'non-national-receipt',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalSummary: {
        route: 'non-national-summary',
        title: VIEW_APPLICATION,
      },
      nonNationalAdditionalDocuments: {
        route: 'non-national-additional-documents',
        title: EXAM_WITHDRAWAL,
      },
      nonNationalTransactionHistory: {
        route: 'non-national-transaction-history',
        title: VIEW_APPLICATION,
      },
    },
  },
  admin: {
    child: {
      configuration: {
        route: 'system-settings',
        title: 'System Settings',
      },
      tasklist: {
        route: 'my-tasks',
        title: 'My Tasks',
      },
      requestlist: {
        route: 'my-requests',
        title: 'My Requests',
      },
      iExams2Configuration: {
        route: 'iexams2-configuration',
        title: 'iExams2 Configuration',
      },
      orgAdminResultRelease: {
        route: 'admin-result-release',
        title: 'Result Release',
      },
      orgAdminIndividualResult: {
        route: 'organization-admin-candidate-result',
        title: 'Candidate Result',
      },
      userAccessConfiguration: {
        route: 'user-access-configuration',
        title: 'User Access Configuration',
      },
      featuresConfiguration: {
        route: 'features-configuration',
        title: 'Features Configuration',
      },
      auditSettings: {
        route: 'audit-settings',
        title: 'Audit Settings',
      },
      accountManagement: {
        route: 'user-account-management',
        title: 'User Account Management',
      },
      accessRole: {
        route: 'admin-access-configuration',
        title: 'Admin Access Configuration',
      },
      transactionLog: {
        route: 'transaction-log',
        title: 'Transaction Log',
      },
      iExams2CandidateCreate: {
        route: 'bulk-candidate-creation',
        title: 'Bulk Candidate Creation',
      },
      oopAdminResitApply: {
        route: 'ops-admin-resit',
        title: 'Resit',
      },
      oopAdminResitRegisteredExam: {
        route: 'ops-admin-registered-exam',
        title: 'Resit Registered Exam',
      },
      oopAdminIndividualResitRegisteredExam: {
        route: 'ops-admin-individual-registered-exam',
        title: 'Candidate Registered Details',
      },
      opAdminResultsAppeal: {
        route: 'ops-admin-results-appeal',
        title: 'Results Appeal',
      },
      opAdminResultsAppealDetails: {
        route: 'ops-admin-results-appeal-details',
        title: 'Results Appeal Details',
      },
      opAdminRegistrationReport: {
        route: 'ops-admin-registration-report',
        title: 'Registration Report',
      },
      nationalReport: {
        route: 'national-report',
        title: '',
      },
      nonNationalReport: {
        route: 'non-national-report',
        title: '',
      },
      opAdminPaymentReport: {
        route: 'ops-admin-payment-report',
        title: 'Payment Report',
      },
      specialConsiderationReport: {
        route: 'special-consideration-report',
        title: 'Special Consideration Report',
      },
      uniqueLink: {
        route: 'unique-link',
        title: 'Grant Registration Link',
      },
      withdrawalLink: {
        route: 'withdrawal-link',
        title: 'Grant Withdrawal Link',
      },
      nonNationalExamApplication: {
        route: 'non-national-exam-application',
        title: 'Applications Review',
      },
      candidateBlacklist: {
        route: 'blacklisted-candidates',
        title: 'Candidates Blacklist',
      },
      addCandidateBlacklist: {
        route: 'add-blacklisted-candidates',
        title: 'Add Candidate to Blacklist',
      },
      accessArrangementConfiguration: {
        route: 'access-arrangements-configuration',
        title: 'Access Arrangements Configuration',
      },
      specialConsideration: {
        route: SPECIAL_CONSIDERATION,
        title: 'Special Consideration',
      },
      examConfiguration: {
        route: 'exam-configuration',
        title: 'Non-National Exam Configuration',
      },
      announcementsConfiguration: {
        route: 'announcements-configuration',
        title: 'Announcements Configuration',
      },
      oopAdminResultAppealAccess: {
        route: 'ops-admin-result-appeal-access',
        title: 'Result Appeal Access',
      },
      /* For Non National Examinations */
      nonNationalExaminations: {
        route: 'non-national-examinations',
      },
      parentParticulars: {
        route: 'parent-particulars',
      },
      candidateDetails: {
        route: 'candidate-details',
      },
      examSchoolingDetails: {
        route: 'exam-schooling-details',
      },
      uploadSupportingDocuments: {
        route: 'upload-supporting-documents',
      },
      confirmParticulars: {
        route: 'confirm-particulars',
      },
      confirmAndPay: {
        route: CONFIRM_AND_PAY,
      },
      receipt: {
        route: 'view-receipt',
      },
      summary: {
        route: VIEW_SUMMARY,
      },
      withdrawal: {
        route: 'withdrawal',
      },
      usefulInformation: {
        route: USEFUL_INFORMATION,
        title: 'Useful Information',
      },
      opsAdminAccessArrangementReport: {
        route: 'access-arrangements-report',
        title: 'Access Arrangement Report',
      },
      orgAdminNonNationalResult: {
        route: 'non-national-examination-results',
        title: 'Result Release',
      },
      nonNationalWithdrawalReason: {
        route: 'non-national-reason',
        title: 'Applications Review',
      },
      manageAnnouncements: {
        route: 'manage-announcements',
        title: 'Manage Announcements',
      },
      createNewAnnouncement: {
        route: 'create-new-announcement',
        title: 'New Announcement',
      },
      createNewBroadcastMessage: {
        route: 'create-new-broadcast-message',
        title: 'New Broadcast Message',
      },
      createNewFAQ: {
        route: 'create-new-faq',
        title: 'New FAQ',
      },
      createNewAdvisoryBanner: {
        route: 'create-new-advisory-banner',
        title: 'New Advisory Banner',
      },
      createNewPaymentMessage: {
        route: 'create-new-payment-message',
        title: 'New Payment Message',
      },
      editAnnouncement: {
        route: 'edit-announcement',
        title: 'Edit Announcement',
      },
      editBroadcastMessage: {
        route: 'edit-broadcast-message',
        title: 'Edit Broadcast Message',
      },
      editFAQ: {
        route: 'edit-faq',
        title: 'Edit FAQ',
      },
      editAdvisoryBanner: {
        route: 'edit-advisory-banner',
        title: 'Edit Advisory Banner',
      },
      editPaymentMessage: {
        route: 'edit-payment-message',
        title: 'Edit Payment Message',
      },
      manageNotifications: {
        route: 'manage-notifications',
        title: 'Manage Notifications',
      },
      createEmailTemplate: {
        route: 'create-email-template',
        title: 'Create Email Notification Template',
      },
      createSMSTemplate: {
        route: 'create-sms-template',
        title: 'Create SMS Notification Template',
      },
      editEmailTemplate: {
        route: 'edit-email-template',
        title: 'Edit Email Notification Template',
      },
      editSMSTemplate: {
        route: 'edit-sms-template',
        title: 'Edit SMS Notification Template',
      },
      sendEmailNotification: {
        route: 'send-email-notification',
        title: 'Send Email Notification',
      },
      sendSMSNotification: {
        route: 'send-sms-notification',
        title: 'Send SMS Notification',
      },
      editEmailNotification: {
        route: 'edit-email-notification',
        title: 'Edit Send Email Notification',
      },
      editSMSNotification: {
        route: 'edit-sms-notification',
        title: 'Edit Send SMS Notification',
      },
      viewEmailNotification: {
        route: 'view-email-notification',
        title: 'View Email Notification',
      },
      viewSMSNotification: {
        route: 'view-sms-notification',
        title: 'View SMS Notification',
      },
      auditReport: {
        route: 'audit-report',
        title: 'Audit Report',
      },
      notificationReport: {
        route: 'notification-report',
        title: 'Notification Report',
      },
      userGroupAccessConfiguration: {
        route: 'user-group-access-configuration',
        title: 'User Group and Access Configuration',
      },
      createUserGroup: {
        route: 'create-user-group',
        title: 'Create User Group',
      },
      editUserGroup: {
        route: 'edit-user-group',
        title: 'Edit User Group',
      },
      viewUserGroup: {
        route: 'view-user-group',
        title: 'View User Group',
      },
      editAccessConfiguration: {
        route: 'edit-access-configuration',
        title: 'Edit Access Configuration',
      },
      viewAccessConfiguration: {
        route: 'view-access-configuration',
        title: 'View Access Configuration',
      },
      userAccountManagement: {
        route: 'new-user-account-management',
        title: 'User Account Management',
      },
      adminAccountManagement: {
        route: 'new-admin-account-management',
        title: 'Admin Account Management',
      },
      viewDetails: {
        route: 'view-details',
        title: 'View Details',
      },
      dataArchival: {
        route: 'data-archival',
        title: 'Data Archival',
      },
      newDataArchival: {
        route: 'new-data-archival',
        title: 'New Data Archival',
      },
      viewDataArchival: {
        route: 'view-data-archival',
        title: 'View Details',
      },
      dataArchivalReport: {
        route: 'data-archival-report',
        title: 'Data Archival Report',
      },
      viewDataArchivalReport: {
        route: 'view-data-archival-report',
        title: 'View Details',
      },
      statementOfResults: {
        route: STATEMENT_OF_RESULTS,
        title: statementOfResultsTitle,
      },
      profileAmendmentRequests: {
        route: 'profile-amendment-requests',
        title: 'Profile Amendment Requests',
      },
      reviewProfileAmendmentApplication: {
        route: 'review-profile-amendment-application',
        title: 'View Details',
      },
      jobStatusReport: {
        route: 'job-status-report',
        title: 'Job Status Report',
      },
      viewRecordDetails: {
        route: 'view-details',
        title: 'View Details',
      },
    },
  },
  result: {
    child: {
      myExaminations: {
        route: 'my-examinations',
        title: 'My Examinations',
      },
      myExaminationsResults: {
        route: 'my-results',
        title: 'Results',
      },
      detailExamSeries: {
        route: 'exam-series',
        title: 'Exam Series',
      },
      blankPage: {
        route: 'blank-page',
        title: 'Blank Page',
      },
      coordinatorResultList: {
        route: 'coordinator-result',
        title: 'Results',
      },
      coordinatorResultRelease: {
        route: 'coordinator-result-release',
        title: 'Result Listing',
      },
      coordinatorIndividualResult: {
        route: 'coordinator-admin-candidate-result',
        title: 'Candidate Result Details',
      },
    },
  },
  appeal: {
    child: {
      applications: {
        route: 'applications',
        title: 'Appeal for Review of Results Application(s)',
      },
      applicationsCoordinator: {
        route: 'applications-coordinator',
        title: 'Appeal for Review of Results Application(s)',
      },
      importantNotes: {
        route: 'important-notes',
        title: AppealForResultReview,
      },
      selectCandidate: {
        route: 'select-candidate',
        title: AppealForResultReview,
      },
      selectSubject: {
        route: SELECT_SUBJECT,
        title: AppealForResultReview,
      },
      reviewApplication: {
        route: REVIEW_APPLICATION,
        title: AppealForResultReview,
      },
      receipt: {
        route: 'receipt',
        title: AppealForResultReview,
      },
      summary: {
        route: 'summary',
        title: AppealForResultReview,
      },
    },
  },
  exam: {
    child: {
      examRegistrations: {
        route: EXAM_REGISTRATION,
        title: REGISTERED_EXAM,
      },
      registerExam: {
        route: 'register-exam',
        title: candidateRegisterForAnExamLabel,
      },
      selectSubject: {
        route: SELECT_SUBJECT,
        title: candidateRegisterForAnExamLabel,
      },
      viewSelectedSubjects: {
        route: 'view-selected-subjects',
        title: candidateRegisterForAnExamLabel,
      },
      reviewParticulars: {
        route: 'review-particulars',
        title: candidateRegisterForAnExamLabel,
      },
      reviewExam: {
        route: CONFIRM_AND_PAY,
        title: candidateRegisterForAnExamLabel,
      },
      receipt: {
        route: 'view-receipt',
        title: candidateRegisterForAnExamLabel,
      },
      summary: {
        route: VIEW_SUMMARY,
        title: VIEW_REGISTRATION,
      },
      transactionHistoryRegistration: {
        route: 'transaction-history-registration',
        title: VIEW_REGISTRATION,
      },

      /* For Non National Examinations */
      nonNationalExaminations: {
        route: 'non-national-examinations',
      },
      parentParticulars: {
        route: 'parent-particulars',
      },
      candidateDetails: {
        route: 'candidate-details',
      },
      examSchoolingDetails: {
        route: 'exam-schooling-details',
      },
      uploadSupportingDocuments: {
        route: 'upload-supporting-documents',
        title: candidateRegisterForAnExamLabel,
      },
      confirmParticulars: {
        route: 'confirm-particulars',
        title: candidateRegisterForAnExamLabel,
      },
      confirmAndPay: {
        route: CONFIRM_AND_PAY,
      },
      uploadAdditionalResources: {
        route: UPLOAD_ADDITIONAL_RESOURCES,
        title: 'Resubmit Application',
      },

      /* for coordinator specific */
      coordinatorEntryProofs: {
        route: 'group-entry-proofs',
        title: 'Entry Proof',
      },
      coordinatorRegisterExam: {
        route: 'coordinator-register-exam',
        title: coordinatorRegisterForAnExamLabel,
      },
      coordinatorReviewCandidates: {
        route: 'coordinator-review-candidates',
        title: coordinatorRegisterForAnExamLabel,
      },
      bulkUploadCandidates: {
        route: 'bulk-upload-candidates',
        title: coordinatorRegisterForAnExamLabel,
      },
      coordinatorReviewExam: {
        route: 'coordinator-review-exam',
        title: coordinatorRegisterForAnExamLabel,
      },
      coordinatorExamRegistrations: {
        route: 'group-exam-registrations',
        title: REGISTERED_EXAM,
      },
      coordinatorViewReceipt: {
        route: 'coordinator-view-receipt',
        title: candidateRegisterForAnExamLabel,
      },
      coordinatorViewSummary: {
        route: 'coordinator-view-summary',
        title: VIEW_REGISTRATION,
      },
      invalid: {
        route: 'invalid',
        title: VIEW_REGISTRATION,
      },
    },
  },
  'special-consideration': {
    child: {
      specialConsideration: {
        route: SPECIAL_CONSIDERATION,
        title: 'Special Consideration',
      },
      instructions: {
        route: 'instructions',
        title: specialConsiderationTitle,
      },
      applyForSpecialConsideration: {
        route: 'apply-for-special-consideration',
        title: specialConsiderationTitle,
      },
      selectSubject: {
        route: SELECT_SUBJECT,
        title: specialConsiderationTitle,
      },
      amendSelectSubject: {
        route: 'amend-select-subject',
        title: specialConsiderationTitle,
      },
      uploadSupportingDocument: {
        route: 'upload-supporting-document',
        title: specialConsiderationTitle,
      },
      amendUploadSupportingDocument: {
        route: 'amend-upload-supporting-document',
        title: specialConsiderationTitle,
      },
      reviewApplication: {
        route: REVIEW_APPLICATION,
        title: specialConsiderationTitle,
      },
      amendReviewApplication: {
        route: 'amend-review-application',
        title: specialConsiderationTitle,
      },
      applicationSummary: {
        route: 'application-summary',
        title: specialConsiderationTitle,
      },
      applicationDetails: {
        route: 'application-details',
        title: VIEW_APPLICATION,
      },
      // coordinator route
      coordinatorUploadRankingDetails: {
        route: 'coordinator-upload-ranking-details',
        title: specialConsiderationTitle,
      },
      amendCoordinatorUploadRankingDetails: {
        route: 'amend-coordinator-upload-ranking-details',
        title: specialConsiderationTitle,
      },
      coordinatorUploadSupportingDocument: {
        route: 'coordinator-upload-supporting-document',
        title: specialConsiderationTitle,
      },
      amendCoordinatorUploadSupportingDocument: {
        route: 'amend-coordinator-upload-supporting-document',
        title: specialConsiderationTitle,
      },
      coordinatorApplicationReview: {
        route: 'coordinator-review',
        title: specialConsiderationTitle,
      },
      amendCoordinatorApplicationReview: {
        route: 'amend-coordinator-review',
        title: specialConsiderationTitle,
      },
      coordinatorApplicationSubmitted: {
        route: 'submitted',
        title: specialConsiderationTitle,
      },
      coordinatorApplicationSummary: {
        route: 'coordinator-summary',
        title: VIEW_APPLICATION,
      },
    },
  },
  resit: {
    child: {
      resitFlow: {
        route: 'resit-registration',
        title: 'Register Year-End MTL Exam',
      },
      eligible: {
        route: 'eligibility',
        title: 'Eligibility',
      },
      listing: {
        route: 'registered-exams',
        title: 'Registered Exams',
      },
      instruction: {
        route: 'register-resit',
        title: 'Register Year-End MTL Exam',
      },
      receipt: {
        route: 'receipt',
        title: 'Year-End MTL Exam Receipt',
      },
      summary: {
        route: 'summary',
        title: 'Registration for Year-End MTL Exam',
      },
      coordinatorListing: {
        route: 'coordinator-registered-exams',
        title: 'Registered Exams',
      },
      coordinatorResitRegister: {
        route: 'coordinator-resit-register',
        title: CoordinatorResitRegistrationTitle,
      },
      coordinatorResitFlow: {
        route: 'coordinator-resit-flow',
        title: CoordinatorResitRegistrationTitle,
      },
    },
  },
  'access-arrangement': {
    child: {
      root: {
        route: 'access-arrangements',
        title: 'Access Arrangements',
      },
      importantNotes: {
        route: 'important-notes',
        title: accessArrangementTitle,
      },
      selectCondition: {
        route: 'select-condition',
        title: accessArrangementTitle,
      },
      individualReport: {
        route: 'individual-report',
        title: accessArrangementTitle,
      },
      accessArrangementsRequest: {
        route: 'access-arrangements-request',
        title: accessArrangementTitle,
      },
      ammendAccessArrangements: {
        route: 'ammend-access-arrangements',
        title: accessArrangementTitle,
      },
      ammendSelectCondition: {
        route: 'ammend-select-condition',
        title: accessArrangementTitle,
      },
      reviewApplication: {
        route: REVIEW_APPLICATION,
        title: accessArrangementTitle,
      },
      submitted: {
        route: 'submitted',
        title: accessArrangementTitle,
      },
      summary: {
        route: 'summary',
        title: VIEW_APPLICATION,
      },
      /* for coordinator specific */
      coordinatorRoot: {
        route: 'coordinator-access-arrangements',
        title: 'Access Arrangements',
      },
      coordinatorImportantNotes: {
        route: 'coordinator-important-notes',
        title: accessArrangementTitle,
      },
      coordinatorSelectCandidate: {
        route: 'coordinator-select-candidate',
        title: accessArrangementTitle,
      },
      coordinatorSelectCondition: {
        route: 'coordinator-select-condition',
        title: accessArrangementTitle,
      },
      coordinatorAccessArrangementsRequest: {
        route: 'coordinator-access-arrangements-request',
        title: accessArrangementTitle,
      },
      coordinatorIndividualReport: {
         route: 'coordinator-individual-report',
         title: accessArrangementTitle,
      },
      coordinatorReviewApplication: {
        route: 'coordinator-review-application',
        title: accessArrangementTitle,
      },
      coordinatorSubmitted: {
        route: 'coordinator-submitted',
        title: accessArrangementTitle,
      },
      coordinatorSummary: {
        route: 'coordinator-summary',
        title: VIEW_APPLICATION,
      },
      coordinatorAmendSelectCondition: {
        route: 'coordinator-amend-select-condition',
        title: accessArrangementTitle,
      },
      coordinatorAmendAccessArrangements: {
        route: 'coordinator-amend-access-arrangements',
        title: accessArrangementTitle,
      },
    },
  },
  'resit-registration': {
    child: {
      // coordinator
      coordinatorResitTransaction: {
        route: 'coordinator-resit-transaction',
        title: 'Candidate Resit Registration Transaction',
      },
      coordinatorSendEmailSuccess: {
        route: 'coordinator-send-email-success',
        title: 'Candidate Resit Registration Summary',
      },
    },
  },
  transaction: {
    child: {
      candidate: {
        route: 'records',
        title: 'Transactions',
      },
      coordinator: {
        route: 'candidate-listing',
        title: 'Transactions',
      },
      viewDetails: {
        route: 'details',
        title: 'View Details',
      },
    },
  },
  error: {
    child: {
      unknown: 'not-exist',
      serverNotFound: '404',
      serverError: '500',
      serviceUnavailable: '503',
      authorized: '403',
      invalid: 'invalid',
      generic: 'generic',
      invalidLink: 'invalid-link',
      maintenance: 'maintenance',
      unSupportedBrowser: 'unsupported-browser',
      serverBusy: 'server-busy',
    },
  },
  'payment-link': {
    child: {
      expired: 'expired',
      used: 'used',
      invalid: 'invalid',
      receipt: 'receipt',
      summary: 'summary',
      resit: 'resit',
      appealRegistration: 'appeal-registration',
      examRegistration: 'exam-registration',
      amendmentRegistration: 'amendment-registration',
    },
  },
  'unique-link': {
    child: {
      registration: 'registration',
      invalid: 'invalid',
    },
  },
  'useful-information': {
    child: {
      root: {
        route: USEFUL_INFORMATION,
        title: 'Useful Information',
      },
      addResource: {
        route: 'add-resource',
        title: 'Add Resource',
      },
      editResource: {
        route: 'edit-resource',
        title: 'Edit Resource',
      },
    },
  },
  announcement: {
    child: {
      allNotices: {
        route: 'all-notices',
        title: 'All Notices',
      },
    },
  },
  'notification-acknowledgement': {
    child: {
      root: {
        route: NOTIFICATION_ACKNOWLEDGEMENT,
      },
    },
  },
  'statement-of-results': {
    child: {
      root: {
        route: 'statement-of-results',
        title: 'Statement of Results',
      },
    },
  },
  payment: {
    child: {
      schoolCandidatePayment: {
        route: 'school-candidate-payment',
        title: 'School Candidate Payment',
        child: {
          receipt: {
            route: 'receipt',
            title: 'Receipt',
          },
        },
      },
      schoolCandidateAppealPayment: {
        route: 'school-candidate-appeal-payment',
        title: 'School Candidate Appeal Payment',
        child: {
          receipt: {
            route: 'receipt',
            title: 'Receipt',
          },
        },
      },
    },
  },
  child: {
    announcement: 'announcement',
    auth: 'auth',
    profile: 'profile',
    singpass: 'sp/consent/callback',
    myinfo: 'mi/consent/callback',
    mims: 'mims/consent/callback',
    eNetsInterimResult: 'enets-interim-result',
    admin: 'admin',
    amendment: 'amendment',
    withdrawal: 'withdrawal',
    result: 'result',
    appeal: 'appeal',
    resit: 'resit',
    exam: 'exam',
    resitRegistration: 'resit-registration',
    error: 'error',
    paymentLink: 'payment-link',
    faq: 'faq',
    privacyStatement: 'privacy-statement',
    termsOfUse: 'terms-of-use',
    notSupport: 'not-support',
    accessArrangement: 'access-arrangement',
    withdraw: 'withdraw',
    uniqueLink: 'unique-link',
    specialConsideration: SPECIAL_CONSIDERATION,
    usefulInformation: USEFUL_INFORMATION,
    statementOfResults: STATEMENT_OF_RESULTS,
    transaction: 'transaction',
    notificationAcknowledgement: 'notification-acknowledgement',
    payment: 'payment',
  },
};
export default key;
